import React, { useState } from "react";
import "./Offert.css";
  
export default function Offert() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    businessName: "",
    email: "",
    subject: "",
    phoneNumber: "",
    message: "",
  });

  const [errors, setErrors] = useState({
    firstName: false,
    lastName: false,
    businessName: false,
    email: false,
    subject: false,
    phoneNumber: false,
    message: false,
  });

  const [messageSent, setMessageSent] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value.trim() === "",
    }));
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    // Validation logic
    const formErrors = {
      firstName: formData.firstName.trim() === "",
      lastName: formData.lastName.trim() === "",
      businessName: false, // No validation for businessName
      email: !/^\S+@\S+\.\S+$/.test(formData.email),
      subject: formData.subject.trim().length < 3,
      phoneNumber: false, // No validation for phoneNumber
      message: formData.message.trim().length < 3,
    };
    setErrors(formErrors);

    // Check if there are any validation errors
    if (Object.values(formErrors).some((error) => error)) {
      console.log("Please fill out the required fields");
      return;
    }

    try {
      const response = await fetch("http://176.10.229.252:3000/contact", {
        method: "POST",
         headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const responseData = await response.json();
      console.log(responseData);
      setMessageSent(true);

      // Reset form data after successful submission
      setFormData({
        firstName: "",
        lastName: "",
        businessName: "",
        email: "",
        subject: "",
        phoneNumber: "",
        message: "",
      });

      setTimeout(() => {
        setMessageSent(false);
      }, 3000);
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <div className="container-contact">
  

      <div className="container-text">
        <h1 id="contactus">Få Offert</h1>
        <p className="description">
        Vi återkommer med en offert inom en arbetsdag.
       </p>
        <div className="form-wrapper">
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-input-half" id="form-input-half-1">
                <input
                  type="text"
                  className={`form-input ${errors.firstName ? "error" : ""}`}
                  placeholder="Förnamn*"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-input-half" id="form-input-half-2">
                <input
                  type="text"
                  className={`form-input ${errors.lastName ? "error" : ""}`}
                  id="lastname"
                  placeholder="Efternamn*"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="form-row">
              <input
                type="text"
                className="form-input-long"
                placeholder="Hur stort är utrymmet i kvadratmeter?"
                name="businessName"
                value={formData.businessName}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-row">
              <input
                type="text"
                className={`form-input-long ${errors.email ? "error" : ""}`}
                placeholder="E-post*"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-row">
            <div className="form-input-half" id="form-input-half-3">
                <input
                  type="number"
                  className="form-input"
                  id="phonenumber"
                  placeholder="Telefonnummer"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-input-half" id="form-input-half-4">
                <input
                  type="text"
                  className={`form-input ${errors.subject ? "error" : ""}`}
                  placeholder="Vad ska ingå i renoveringen?"
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="message-container">
              <textarea
                id="form-input-message"
                placeholder="Beskriv uppdraget så tydligt du kan*"
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                onBlur={() => {
                  setErrors((prevErrors) => ({
                    ...prevErrors,
                    message: formData.message.trim().length < 3,
                  }));
                }}
                className={`${
                  errors.message ? "form-input error" : "form-input"
                }`}
              ></textarea>
            </div>
            <button
              className="form-submit sent-icon"
              id="sent"
              type="submit"
              onClick={handleSubmit}
            >
              Skicka
            </button>
            {Object.values(errors).some((error) => error) && (
              <p className="error-message">
                Var god fyll i de markerade fälten med korrekt information.
              </p>
            )}
            {messageSent && (
              <p className="message-sent">
                Ditt meddelande har skickats till Tak Till Golv. De kommer att kontakta dig inom 24-48 timmar.

              </p>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}
